import React, { FC } from 'react';
import classNames from 'classnames';

import styles from './column.module.scss';

type Props = {
  className?: string;
  small?: number;
  medium?: number;
  large?: number;
  xLarge?: number;
  offsetSmall?: number;
  offsetMedium?: number;
  offsetLarge?: number;
  offsetXLarge?: number;
  'data-test-id'?: string;
};

export const Column: FC<Props> = ({
  children,
  className,
  small = 12,
  medium,
  large,
  xLarge,
  offsetSmall,
  offsetMedium,
  offsetLarge,
  offsetXLarge,
  ...props
}) => {
  const columnClass = classNames(
    styles.column,
    className,
    Boolean(small) && styles[`col-sm-${small}`],
    Boolean(medium) && styles[`col-md-${medium}`],
    Boolean(large) && styles[`col-lg-${large}`],
    Boolean(xLarge) && styles[`col-xl-${xLarge}`],
    Boolean(offsetSmall) && styles[`offset-sm-${offsetSmall}`],
    Boolean(offsetMedium) && styles[`offset-md-${offsetMedium}`],
    Boolean(offsetLarge) && styles[`offset-lg-${offsetLarge}`],
    Boolean(offsetXLarge) && styles[`offset-xl-${offsetXLarge}`],
  );
  return (
    <div className={columnClass} data-test-id={props['data-test-id']}>
      {children}
    </div>
  );
};
